<template>
  <div style="position: relative;" class="bg-white p-4">
    <div class="inner-pag active">
      <QuestionSetAnswering :goBack="goBack"></QuestionSetAnswering>
    </div>
  </div>
</template>

<script>
import QuestionSetAnswering from "./question-set-answering.vue";
export default {
  components: { QuestionSetAnswering },
  methods: {
    goBack() {
      this.$router.push(`/${this.currentProduct ? this.currentProduct.toLowerCase() : "organization"}/question-set-survey`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./question-set";
</style>
